import { useEffect } from 'react';
import { useCompatRouter } from '../hooks/useCompatRouter';

const BookingPreviewPageRedirect = () => {
  const router = useCompatRouter();

  useEffect(() => {
    if (!router.isReady) {
      return;
    }

    try {
      // Preserve any query params (for example: id=B0001) and ensure mode=view if not provided
      const params = new URLSearchParams(typeof window !== 'undefined' ? window.location.search : '');
      if (!params.has('mode')) params.set('mode', 'view');
      const search = params.toString();
      void router.replace(`/booking-system/booking-form?${search}`);
    } catch (err) {
      // Fallback to the default route if anything goes wrong
      void router.replace('/booking-system/booking-form?mode=view');
    }
  }, [router]);

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Redirecting to booking preview...</p>
      </div>
    </div>
  );
};

export default BookingPreviewPageRedirect;